"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _RatioBox = _interopRequireDefault(require("../../RatioBox/RatioBox.index"));

var _Gallery = require("../Gallery.types");

var _Carousel = require("./Carousel.styles");

var _Carousel2 = _interopRequireDefault(require("./Carousel.utils"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      activeIndex = _ref.activeIndex,
      onIndexChange = _ref.onIndexChange,
      theme = _ref.theme;
  var slider = (0, _react.useRef)();

  var _ref2 = theme !== null && theme !== void 0 ? theme : {},
      _ref2$gallery = _ref2.gallery;

  _ref2$gallery = _ref2$gallery === void 0 ? {} : _ref2$gallery;
  var ratio = _ref2$gallery.ratio;
  (0, _react.useEffect)(function () {
    var _slider$current;

    var _ref3 = (_slider$current = slider.current) !== null && _slider$current !== void 0 ? _slider$current : {},
        scrollWidth = _ref3.scrollWidth;

    var pageWidth = scrollWidth / children.length;
    (0, _Carousel2["default"])(slider.current, pageWidth * activeIndex, true);
  }, [activeIndex]);
  var handleScroll = (0, _debounce["default"])(function () {
    var _slider$current2;

    var _ref4 = (_slider$current2 = slider.current) !== null && _slider$current2 !== void 0 ? _slider$current2 : {},
        scrollLeft = _ref4.scrollLeft,
        scrollWidth = _ref4.scrollWidth;

    var pageWidth = scrollWidth / children.length;
    var currentSlide = 0;

    if (scrollLeft === 0) {
      currentSlide = 1;
    } else {
      currentSlide = Math.round(scrollLeft / pageWidth) + 1;
    }

    if (onIndexChange) {
      onIndexChange(currentSlide - 1);
    }
  }, 100); // add the mobile swipe scroll thing

  return /*#__PURE__*/_react["default"].createElement(_Carousel.CarouselWindow, {
    ratio: ratio
  }, /*#__PURE__*/_react["default"].createElement(_Carousel.Viewport, null, /*#__PURE__*/_react["default"].createElement(_Carousel.Slider, {
    ref: slider
  }, children.map(function (child, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement(_Carousel.SliderItemOuter, {
        key: "carousel-item-".concat(index),
        onScroll: handleScroll
      }, /*#__PURE__*/_react["default"].createElement(_Carousel.SliderItem, null, /*#__PURE__*/_react["default"].createElement(_RatioBox["default"], {
        ratio: ratio
      }, child)))
    );
  }))));
};

Carousel.propTypes = {
  children: _propTypes["default"].node,
  activeIndex: _propTypes["default"].number,
  onIndexChange: _propTypes["default"].func,
  theme: _Gallery.galleryTheme
};
Carousel.defaultProps = {
  children: [],
  activeIndex: undefined,
  onIndexChange: undefined,
  theme: undefined
};
Carousel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Carousel",
  "props": {
    "children": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "activeIndex": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "onIndexChange": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "theme": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "custom",
        "raw": "galleryTheme"
      },
      "required": false
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Carousel);

exports["default"] = _default;